// extracted by mini-css-extract-plugin
module.exports = {"heading":"SuggestedCategories_heading__N93WN","list":"SuggestedCategories_list__6B5pI"};